export default __webpack_public_path__ + "static/media/Logo_Full_Red.71649ae7.svg";